function addControlButtons() {
  const cart = document.querySelector("#cart-drawer .drawer__inner");  
  const cartFooter = cart.querySelector(".cart__form");

  if (!cartFooter) {
    return;
  }

  const apiKey = "83b648151853dc9fbf7153e4b45ff3fd";

  cart.style["overflow-y"] = "hidden";
  const defaultLanguage = "uk-UA";
  const language = window?.Shopify?.locale || defaultLanguage;
  let translations = {};
/**THIS PART COMMENTED COUSE OF WRONG SETTINGS SITE LANGUAGE. SETTED EN BY DEFAULT. 
 * Need to change default lang on UA for website.
 */
  // if (language !== defaultLanguage) {
  //   translations = {
  //     shipping: "Choose a delivery method",
  //     chooseDeliveryMethod: "Choose a delivery method",
  //     options: {
  //       warehouse: "NovaPoshta",
  //       internationalDelivery: "International delivery",
  //     },
  //     inputPlaceholders: {
  //       name: "First and Last names",
  //       phone: "Phone number",
  //       settlement: "Select a settlement",
  //       warehouse: "Select branch / post office",
  //     },
  //   };
  // } else {
    // uk by default
    translations = {
      shipping: "Оберіть спосіб доставки",
      chooseDeliveryMethod: "Оберіть спосіб доставки",
      options: {
        warehouse: "Доставка Новою Поштою",
        internationalDelivery: "Міжнародна доставка",
      },
      inputPlaceholders: {
        name: "Ім'я та прізвище",
        phone: "Номер телефону",
        settlement: "Оберіть населений пункт",
        warehouse: "Оберіть відділення або поштомат",
      },
    };

  const cartSubmitButton = cartFooter.querySelector(".cart__buttons");

  const deliveryTypeRadios = cart.querySelectorAll(
    ".overlay-form__radio-input"
  );
  const inputs = cart.querySelectorAll(".overlay-form__input");

  // Disable inputs when international delivery is selected
  deliveryTypeRadios.forEach((radio) => {
    radio.addEventListener("change", (event) => {
      const deliveryType = event.target.value;

      if (deliveryType === "international-delivery") {
        inputs.forEach((input) => {
          if (input.name === "name") return;
          input.disabled = true;
        });
      } else {
        inputs.forEach((input) => {
          input.disabled = false;
        });
      }
    });
  });

  const cartComtrolButtonsBlock = cart.querySelector(".cart-controls");
  const controlButtons = cart.querySelector(".cart-controls__buttons");
  const overlay = cart.querySelector(".cart-controls__overlay");
  const overlayCloseBtn = cart.querySelector(".controls-overlay__close-button");
  const suggestionsLists = cart.querySelectorAll(".overlay-form__suggestions");
  const submitButton = cartFooter.querySelector('button[type="submit"][name="checkout"]');
  const originalSubmitButtonText = submitButton.innerHTML;
  let deliveryCity = "";

  overlayCloseBtn.addEventListener("click", toggleOverlay);

  // Open overlay on button click
  controlButtons.addEventListener("click", (event) => {
    if (event.target.closest(".control-button")) {
      toggleOverlay();
    }
  });

  let currentInputId = null;
  inputs.forEach((input) => {
    // Fetch data on input change
    input.addEventListener("input", (event) => {
      const value = event.target.value.trim();
      const inputId = event.target.id;

      if (value) {
        if (inputId === "settlement") {
          const requestBody = {
            "apiKey": apiKey,
            "modelName": "Address",
            "calledMethod": "searchSettlements",
            "methodProperties": {
              "CityName": value,
              "Limit": "20"
            }
          };

          fetch("https://api.novaposhta.ua/v2.0/json/", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(requestBody)
          })
          .then((response) => response.json())
          .then((data) => {
            const filteredSettlements = [];
            
            data.data[0]["Addresses"].forEach(address => {
              filteredSettlements.push({
                Present: address.Present,
                DeliveryCity: address.DeliveryCity,
                Ref: address.Ref
              })
            })
            // Display suggestions (elastic search)
            displaySuggestions(inputId, filteredSettlements);
          })
          .catch((error) => {
            console.error("Error:", error);
          });
        } else if (inputId === "warehouse") {
          const requestBody = {
            "apiKey": apiKey,
            "modelName": "AddressGeneral",
            "calledMethod": "getWarehouses",
            "methodProperties": {
              "FindByString" : value,
              "CityRef" : deliveryCity,
              "Limit": "20"
            }
          };

          fetch("https://api.novaposhta.ua/v2.0/json/", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(requestBody)
          })
          .then((response) => response.json())
          .then((data) => {
            const filteredWarehouses = [];
            data.data.forEach(warehouse => {
              filteredWarehouses.push({
                Description: warehouse.Description,
                Ref: warehouse.Ref,
              })
            })
            // Display suggestions (elastic search)
            displaySuggestions(inputId, filteredWarehouses);
          })
          .catch((error) => {
            console.error("Error:", error);
          });
        }
      } else {
        // Clear suggestions (elastic search) if input is empty
        if (inputId === "name") {
          return;
        }

        clearSuggestions(inputId);
      }
    });
  });

  // Close suggestions on click outside
  document.addEventListener("click", (event) => {
    const isInput = event.target.classList.contains("overlay-form__input");
    const isSuggestion = event.target.classList.contains(
      "overlay-form__suggestions"
    );
    const isCurrentInput = event.target.id === currentInputId;

    if ((!isInput && !isSuggestion) || !isCurrentInput) {
      suggestionsLists.forEach((list) => {
        list.style.display = "none";
      });
    }
  });

  let isHovered = false;
  let isOriginalText = true;

  // Change submit button text on hover
  submitButton.addEventListener("mouseover", () => {
    if (!isHovered) {
      changeSubmitButtonText(
        `${translations.chooseDeliveryMethod}`
      );
      isHovered = true;
      isOriginalText = false;
    }
  });

  submitButton.addEventListener("mouseout", () => {
    if (!isOriginalText) {
      changeSubmitButtonText(originalSubmitButtonText);
      isHovered = false;
      isOriginalText = true;
    }
  });

  submitButton.addEventListener("click", async (event) => {
    event.preventDefault();
    // Get delivery info
    const { deliveryType, name, settlement, warehouse } =
      getDeliveryInfo();
    const isWarehouse = deliveryType === "warehouse";

    // Open overlay if name or phone is not selected
    if (!name) {
      if (!overlay.classList.contains("active")) {
        toggleOverlay();
      }
      return;
    }

    // Open overlay if warehouse delivery is selected but settlement or warehouse is not selected
    if (isWarehouse) {
      if (!settlement || !warehouse) {
        if (!overlay.classList.contains("active")) {
          toggleOverlay();
        }
        return;
      }
    }

    // Cart attributes
    const names = name?.split(" ");
    const firstName = names?.shift();
    const lastName = names?.join(" ");
    const attributes = isWarehouse
      ? {
          _provider: "Нова пошта",
          _delivery_method: "Відділення / Поштомат",
          _delivery_first_name: firstName,
          _delivery_last_name: lastName,
          _delivery_city: settlement,
          _delivery_warehouse: warehouse,
          _delivery_warehouse_zip: "11111",
        }
      : {
          _provider: "",
          _delivery_method: "Міжнародна доставка",
          _delivery_first_name: firstName,
          _delivery_last_name: lastName,
          _delivery_city: "",
          _delivery_warehouse: "",
          _delivery_warehouse_zip: "",
        };

    try {
      // Update cart attributes
      await fetch("/cart/update.js", {
        method: "POST",
        mode: "cors",
        credentials: "include",
        cache: "no-cache",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          attributes,
        }),
      });

      const geoResponse = await fetch("https://ipinfo.io/json");
      const geo = await geoResponse.json();
      const countryCode = geo?.country;

      // Add delivery info to cart note
      const address = isWarehouse
        ? {
            countryCode: "UA",
            country: "Ukraine",
            address1: warehouse,
            zip: "11111",
            city: settlement,
            first_name: firstName,
            last_name: lastName
          }
        : {
            countryCode: countryCode,
            country: countries[countryCode],
            address1: "",
            zip: "",
            city: "",
            first_name: firstName,
            last_name: lastName
          };

      const response = await fetch("/cart.json");
      const data = await response.json();

      const pairs = [],
        path = data.items
          .map((item) => `${item.variant_id}:${item.quantity}`)
          .join(",");
      for (const key in attributes) {
        if (!attributes[key]) continue;
        const pair = `attributes[${key}]=${attributes[key]}`;
        pairs.push(pair);
      }
      for (const key in address) {
        let pair = `checkout[shipping_address][${key}]=${address[key]}`;
        pairs.push(pair);
      }

      // Redirect to checkout
      let params, url;
      const isDefaultLanguage = defaultLanguage === language;
      
      /**INTERNALIZATION DON'T WORK. 
       * NEED TO CHANGE DEFAULT LANGUAGE BEFORE USE CODE BELOW*/

      // data.note && data.note != null
      //   ? ((params = pairs.join("&") + `&note=${data.note}`),
      //     (url = isDefaultLanguage
      //       ? `/cart/${path}?${params}`
      //       : `/${language}/cart/${path}?${params}`))
      //   : ((params = pairs.join("&")),
      //     (url = isDefaultLanguage
      //       ? `/cart/${path}?${params}`
      //       : `/${language}/cart/${path}?${params}`)),
      //   (window.location.href = url);


      data.note && data.note != null
        ? ((params = pairs.join("&") + `&note=${data.note}`),
          (url = isDefaultLanguage
            ? `/cart/${path}?${params}`
            : `/cart/${path}?${params}`))
        : ((params = pairs.join("&")),
          (url = isDefaultLanguage
            ? `/cart/${path}?${params}`
            : `/cart/${path}?${params}`)),
        (window.location.href = url);

    } catch (error) {
      console.error("Error:", error);
    }
  });

  function getDeliveryInfo() {
    const deliveryType = cart.querySelector(
      'input[name="delivery-type"]:checked'
    ).value;
    const name = cart.querySelector("#name").value;
    const settlement = cart.querySelector("#settlement").value;
    const warehouse = cart.querySelector("#warehouse").value;

    return {
      deliveryType,
      name,
      settlement,
      warehouse,
    };
  }

  // Change submit button text with animation
  function changeSubmitButtonText(text) {
    if (submitButton.innerHTML !== text) {
      const { deliveryType, name, settlement, warehouse } =
        getDeliveryInfo();

      const animate = () => {
        // submitButton.classList.add("change-text-animation");

        setTimeout(() => {
          submitButton.innerHTML = text;
        }, 125); // Animation duration (half of the CSS transition duration)

        setTimeout(() => {
          //submitButton.classList.remove("change-text-animation");
        }, 250); // Animation duration (CSS transition duration)
      };

      if (!name) {
        animate();
        return;
      }

      if (deliveryType === "warehouse") {
        if (!settlement || !warehouse) {
          animate();
        }
      }
    }
  }

  function toggleOverlay() {
    overlay.classList.toggle("active");
    //cartComtrolButtonsBlock.classList.toggle("active");
    if (overlay.classList.contains("active")) {
      submitButton.style.zIndex = "10";
    } else {
      setTimeout(() => {
        submitButton.style.zIndex = "6";
      }, 200);
    }
  }

  function displaySuggestions(inputId, data) {
    currentInputId = inputId;
    const suggestionsList = cart.querySelector(`#suggestions-${inputId}`);
    suggestionsList.innerHTML = "";
    const isSettlement = inputId === "settlement";
    data.forEach((item) => {
      const li = document.createElement("li");
      li.textContent = isSettlement ? item.Present : item.Description;

      li.addEventListener("click", () => {
        cart.querySelector(`#${inputId}`).value = isSettlement
          ? item.Present
          : item.Description;
        clearSuggestions(inputId);

        if (isSettlement) {
          deliveryCity = item.DeliveryCity;
        }
      });

      suggestionsList.appendChild(li);
    });
    suggestionsList.style.display = "block";
  }

  function clearSuggestions(inputId) {
    const suggestionsList = cart.querySelector(`#suggestions-${inputId}`);
    suggestionsList.innerHTML = "";
    suggestionsList.style.display = "none";
  }

  var countries = {
    AF: "Afghanistan",
    AX: "Aland Islands",
    AL: "Albania",
    DZ: "Algeria",
    AS: "American Samoa",
    AD: "Andorra",
    AO: "Angola",
    AI: "Anguilla",
    AQ: "Antarctica",
    AG: "Antigua And Barbuda",
    AR: "Argentina",
    AM: "Armenia",
    AW: "Aruba",
    AU: "Australia",
    AT: "Austria",
    AZ: "Azerbaijan",
    BS: "Bahamas",
    BH: "Bahrain",
    BD: "Bangladesh",
    BB: "Barbados",
    BY: "Belarus",
    BE: "Belgium",
    BZ: "Belize",
    BJ: "Benin",
    BM: "Bermuda",
    BT: "Bhutan",
    BO: "Bolivia",
    BA: "Bosnia And Herzegovina",
    BW: "Botswana",
    BV: "Bouvet Island",
    BR: "Brazil",
    IO: "British Indian Ocean Territory",
    BN: "Brunei Darussalam",
    BG: "Bulgaria",
    BF: "Burkina Faso",
    BI: "Burundi",
    KH: "Cambodia",
    CM: "Cameroon",
    CA: "Canada",
    CV: "Cape Verde",
    KY: "Cayman Islands",
    CF: "Central African Republic",
    TD: "Chad",
    CL: "Chile",
    CN: "China",
    CX: "Christmas Island",
    CC: "Cocos (Keeling) Islands",
    CO: "Colombia",
    KM: "Comoros",
    CG: "Congo",
    CD: "Congo, Democratic Republic",
    CK: "Cook Islands",
    CR: "Costa Rica",
    CI: "Cote D'Ivoire",
    HR: "Croatia",
    CU: "Cuba",
    CY: "Cyprus",
    CZ: "Czech Republic",
    DK: "Denmark",
    DJ: "Djibouti",
    DM: "Dominica",
    DO: "Dominican Republic",
    EC: "Ecuador",
    EG: "Egypt",
    SV: "El Salvador",
    GQ: "Equatorial Guinea",
    ER: "Eritrea",
    EE: "Estonia",
    ET: "Ethiopia",
    FK: "Falkland Islands (Malvinas)",
    FO: "Faroe Islands",
    FJ: "Fiji",
    FI: "Finland",
    FR: "France",
    GF: "French Guiana",
    PF: "French Polynesia",
    TF: "French Southern Territories",
    GA: "Gabon",
    GM: "Gambia",
    GE: "Georgia",
    DE: "Germany",
    GH: "Ghana",
    GI: "Gibraltar",
    GR: "Greece",
    GL: "Greenland",
    GD: "Grenada",
    GP: "Guadeloupe",
    GU: "Guam",
    GT: "Guatemala",
    GG: "Guernsey",
    GN: "Guinea",
    GW: "Guinea-Bissau",
    GY: "Guyana",
    HT: "Haiti",
    HM: "Heard Island & Mcdonald Islands",
    VA: "Holy See (Vatican City State)",
    HN: "Honduras",
    HK: "Hong Kong",
    HU: "Hungary",
    IS: "Iceland",
    IN: "India",
    ID: "Indonesia",
    IR: "Iran, Islamic Republic Of",
    IQ: "Iraq",
    IE: "Ireland",
    IM: "Isle Of Man",
    IL: "Israel",
    IT: "Italy",
    JM: "Jamaica",
    JP: "Japan",
    JE: "Jersey",
    JO: "Jordan",
    KZ: "Kazakhstan",
    KE: "Kenya",
    KI: "Kiribati",
    KR: "Korea",
    KW: "Kuwait",
    KG: "Kyrgyzstan",
    LA: "Lao People's Democratic Republic",
    LV: "Latvia",
    LB: "Lebanon",
    LS: "Lesotho",
    LR: "Liberia",
    LY: "Libyan Arab Jamahiriya",
    LI: "Liechtenstein",
    LT: "Lithuania",
    LU: "Luxembourg",
    MO: "Macao",
    MK: "Macedonia",
    MG: "Madagascar",
    MW: "Malawi",
    MY: "Malaysia",
    MV: "Maldives",
    ML: "Mali",
    MT: "Malta",
    MH: "Marshall Islands",
    MQ: "Martinique",
    MR: "Mauritania",
    MU: "Mauritius",
    YT: "Mayotte",
    MX: "Mexico",
    FM: "Micronesia, Federated States Of",
    MD: "Moldova",
    MC: "Monaco",
    MN: "Mongolia",
    ME: "Montenegro",
    MS: "Montserrat",
    MA: "Morocco",
    MZ: "Mozambique",
    MM: "Myanmar",
    NA: "Namibia",
    NR: "Nauru",
    NP: "Nepal",
    NL: "Netherlands",
    AN: "Netherlands Antilles",
    NC: "New Caledonia",
    NZ: "New Zealand",
    NI: "Nicaragua",
    NE: "Niger",
    NG: "Nigeria",
    NU: "Niue",
    NF: "Norfolk Island",
    MP: "Northern Mariana Islands",
    NO: "Norway",
    OM: "Oman",
    PK: "Pakistan",
    PW: "Palau",
    PS: "Palestinian Territory, Occupied",
    PA: "Panama",
    PG: "Papua New Guinea",
    PY: "Paraguay",
    PE: "Peru",
    PH: "Philippines",
    PN: "Pitcairn",
    PL: "Poland",
    PT: "Portugal",
    PR: "Puerto Rico",
    QA: "Qatar",
    RE: "Reunion",
    RO: "Romania",
    RU: "Russian Federation",
    RW: "Rwanda",
    BL: "Saint Barthelemy",
    SH: "Saint Helena",
    KN: "Saint Kitts And Nevis",
    LC: "Saint Lucia",
    MF: "Saint Martin",
    PM: "Saint Pierre And Miquelon",
    VC: "Saint Vincent And Grenadines",
    WS: "Samoa",
    SM: "San Marino",
    ST: "Sao Tome And Principe",
    SA: "Saudi Arabia",
    SN: "Senegal",
    RS: "Serbia",
    SC: "Seychelles",
    SL: "Sierra Leone",
    SG: "Singapore",
    SK: "Slovakia",
    SI: "Slovenia",
    SB: "Solomon Islands",
    SO: "Somalia",
    ZA: "South Africa",
    GS: "South Georgia And Sandwich Isl.",
    ES: "Spain",
    LK: "Sri Lanka",
    SD: "Sudan",
    SR: "Suriname",
    SJ: "Svalbard And Jan Mayen",
    SZ: "Swaziland",
    SE: "Sweden",
    CH: "Switzerland",
    SY: "Syrian Arab Republic",
    TW: "Taiwan",
    TJ: "Tajikistan",
    TZ: "Tanzania",
    TH: "Thailand",
    TL: "Timor-Leste",
    TG: "Togo",
    TK: "Tokelau",
    TO: "Tonga",
    TT: "Trinidad And Tobago",
    TN: "Tunisia",
    TR: "Turkey",
    TM: "Turkmenistan",
    TC: "Turks And Caicos Islands",
    TV: "Tuvalu",
    UG: "Uganda",
    UA: "Ukraine",
    AE: "United Arab Emirates",
    GB: "United Kingdom",
    US: "United States",
    UM: "United States Outlying Islands",
    UY: "Uruguay",
    UZ: "Uzbekistan",
    VU: "Vanuatu",
    VE: "Venezuela",
    VN: "Viet Nam",
    VG: "Virgin Islands, British",
    VI: "Virgin Islands, U.S.",
    WF: "Wallis And Futuna",
    EH: "Western Sahara",
    YE: "Yemen",
    ZM: "Zambia",
    ZW: "Zimbabwe",
  };
}

window.addEventListener("DOMContentLoaded", () => {
  addControlButtons();
})